import { Article, WholesalerArticle } from "@tm/models"
import { mapDistinctValues } from "@bundles/parts/components/ListV2/helpers"
import { useMemo } from "react"
import { BaseArticleData } from "@bundles/parts/components/ListV2/models"
import { TraderArticle } from "../../../../helpers"

export function useArticles(parts: (Article | TraderArticle)[]): BaseArticleData {
    const articles = parts.filter((a): a is Article => !("isTraderArticle" in a))
    const wholesalerArticles = parts
        .filter((a): a is TraderArticle => "isTraderArticle" in a)
        .map((t): WholesalerArticle => ({ itemId: t.id, wholesalerArticleNumber: t.traderArticleNumber }))
    const supplierIds = mapDistinctValues(articles, (x) => x.supplier.id)
    const productGroupIds = mapDistinctValues(articles, (x) => x.productGroup.id)

    return useMemo(
        () => ({
            articles,
            wholesalerArticles,
            supplierIds,
            productGroupIds,
            requestStatus: "success",
            isEnabled: true,
            isLoading: false,
            isFetchingNextPage: false,
            isLoaded: true,
            isSuccess: true,
            isFailed: false,
            pageCount: 0,
            articleCount: 0,
            loadNextPage: () => null,
            hasNextPage: false,
        }),
        [articles, productGroupIds, supplierIds, wholesalerArticles]
    )
}
